function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCalculatorRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.045 21.459l1.414-1.414 1.552 1.552 1.552-1.552 1.414 1.414-1.552 1.552 1.552 1.552-1.414 1.414-1.552-1.552-1.552 1.552-1.414-1.414 1.552-1.552-1.552-1.552zM3 25a4 4 0 004 4h8V17H3v8zM8 6h2v2h2v2h-2v2H8v-2H6V8h2V6zM3 7v8h12V3H7a4 4 0 00-4 4zM20 26h6v-2h-6v2zm0-4h6v-2h-6v2zm-3 7h8a4 4 0 004-4v-8H17v12zM20 10h6V8h-6v2zm5-7h-8v12h12V7a4 4 0 00-4-4z",
    fill: props.color
  }));
}

export default SvgIconCalculatorRexFilled;